/**
 * calculates width of one cell with video in the stage
 * @param totalTracksNumber
 */
export const getWidth = (totalTracksNumber: number): number => {
    let delimiter = 1;

    if (totalTracksNumber > 1 && totalTracksNumber <= 4) {
        delimiter = 2;
    }
    if (totalTracksNumber > 4 && totalTracksNumber <= 9) {
        delimiter = 3;
    }
    else if (totalTracksNumber > 9) {
        delimiter = 4
    }

    return 100 / delimiter;
}
